import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { timeout } from "rxjs/operators";
import { UserSettingsService } from "./user-setting.service";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class HttpInterceptService implements HttpInterceptor {
  constructor(private readonly authService: UserSettingsService,private readonly route:Router) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes("veritaslegalplan.com")) {
      return next.handle(request);
    }
    if(!this.authService.validateToken()){
      this.authService.logOut();
    }

    return next
      .handle(
        request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.authService.getToken()}`,
          },
        })
      )
      .pipe(timeout(300000 /* 30 seconds */));
  }
}
